import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteGLMKiloFlow(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteGLMKiloFlow = (flowId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`glm-kilo-flows/${flowId}/`);
  };

  return useMutation(deleteGLMKiloFlow, {
    onSuccess: (_data, flowId) => {
      // Remove the deleted flow's detail, invalidate the list so it refetches.
      queryClient.removeQueries(['glm-kilo-flows', flowId]);
      queryClient.invalidateQueries(['glm-kilo-flows'], { exact: true });
    },
  });
}
